import { useState, useEffect } from 'react';
import {Space, Row, Button, message, Table, Divider, PageHeader, Statistic, Card} from 'antd';
import { FetchVariable } from '../../../Components/FetchVariable/FetchVariable';
import CustomerAdd from './CustomerAdd';
import CustomerUpdate from './CustomerUpdate';
import axios from 'axios';
import {DeleteOutlined} from '@ant-design/icons';


const CustomerComponent = () => {

    const [CustomerData, setCustomerData] = useState()
    const [CustomerTotal, setCustomerTotal] = useState([])
    
    const fetchCustomer = () => {
        let getCustomers = `${FetchVariable.Heroku}/customer/`
        axios.get(getCustomers)
            .then((res)=>{
                let data =res.data
                setCustomerData(data)
                setCustomerTotal(data.length)
            })
        };

    function deleteCustomer (deleteID){
            let apiURL = `${FetchVariable.Heroku}/customer/`+deleteID
            axios.delete(apiURL)
                .then(() => {
                    fetchCustomer()
                    message.error('The Customer is deleted')
                })
        };

    const addCustomer = (addCustomerData)=>{
            let apiURL = `${FetchVariable.Heroku}/customer/`
            axios.post(apiURL, addCustomerData)
                .then(res=>
                    {
                        if(res.data.error){
                            //Error Message response has 6 elements if split
                            //Split only up to 3, then join the next 3
                            //Our error should be dynamic if the pattern follows
                            let errorMessage = (res.data.error).split(" ", 3).join(" ", 3)
                            message.error(errorMessage,10);
                    }else{
                        fetchCustomer()
                    }}
                ).catch(err=>{console.log(err)})
        };

    const updateCustomer = (updateCustomer)=>{
            let apiURL = `${FetchVariable.Heroku}/customer/`
            axios.put(apiURL, updateCustomer)
                .then(res=>
                    {
                        if(res.data.error){
                            //Error Message response has 6 elements if split
                            //Split only up to 3, then join the next 3
                            //Our error should be dynamic if the pattern follows
                            let errorMessage = (res.data.error).split(" ", 3).join(" ", 3)
                            message.error(errorMessage);
                    }
                else{
                    fetchCustomer()
                }}
                ).catch(err=>{console.log(err)})
        };

        useEffect(() => {
            fetchCustomer();
        }, [])


    //Helper function to dynamically render our filter
    const filterData = data => formatter => data?.map( item => ({
        text: formatter(item),
        value: formatter(item)
    }));

        const CustomerColums = [
        {
            title: 'Customer ID',
            dataIndex: 'CustomerID',
            key: 'CustomerID',
            width:150,
        },
        {
            title: 'Customer Name',
            dataIndex: 'CustomerName',
            key: 'CustomerName',
            filters: filterData(CustomerData)(i => i.CustomerName),
            // width:250,
            filterSearch: true,
            onFilter: (value, record) => record.CustomerName.indexOf(value) === 0,
            sorter: (a, b) => a.CustomerName.length - b.CustomerName.length,
            sortDirections: ['descend','ascend'],
        },
        {
            title: 'Customer Address',
            dataIndex: 'CustomerAddress',
            key: 'CustomerAddress',
        },
        {
            title: 'Customer Email',
            dataIndex: 'CustomerEmail',
            key: 'CustomerEmail',
            filters: filterData(CustomerData)(i => i.CustomerEmail),
            // width:250,
            filterSearch: true,
            onFilter: (value, record) => record.CustomerEmail.indexOf(value) === 0,
            sorter: (a, b) => a.CustomerEmail.length - b.CustomerEmail.length,
            sortDirections: ['descend','ascend'],
        },
        {
            title: 'Customer Phone',
            dataIndex: 'CustomerPhone',
            key: 'CustomerPhone',
            filters: filterData(CustomerData)(i => i.CustomerPhone),
            width:200,
            filterSearch: true,
            onFilter: (value, record) => record.CustomerPhone.indexOf(value) === 0,
            sorter: (a, b) => a.CustomerPhone.length - b.CustomerPhone.length,
            sortDirections: ['descend','ascend'],
        },
        {
            title: 'Action',
            key: 'action',
            render: (record) => (
              <Space size="middle">
                <CustomerUpdate record={record} updateCustomer={updateCustomer}/>
                <Button onClick={()=>deleteCustomer(record.CustomerID)} type="primary" danger icon={<DeleteOutlined />}></Button>
              </Space>
            ),
          },
    ]

    return(
        <>
            <PageHeader
            className="site-page-header"
            title="Customer Management"
            extra={[ 
                <CustomerAdd key='addCustomer' addCustomer={addCustomer}/>,
            ]}
            >
                <div className="site-card-border-less-wrapper">
                    <Card style={{ width: 250 }}>
                        <Statistic title="Customer Total" value={CustomerTotal} />
                    </Card>
                </div>
            </PageHeader>
            <Divider />
            <Row>
                <Table 
                columns={CustomerColums} 
                dataSource={CustomerData} 
                rowKey={(record)=>record.CustomerID}
                scroll={{ x: 1500, y: 800 }} 
                />
            </Row>
        </>
    )
}

export default CustomerComponent